module.exports = __webpack_public_path__ + "0f9b38eb691e23b1a3f9f4d7408f7583.svg";